<template>
	<div class="row">
		<!-- customar project  start -->
		<div class="col-xl-12">
			<div class="card">
				<div class="card-body">
					<div v-if="parties && parties.length" class="mb-2">
						<button
							@click.prevent="downloadPDF"
							class="btn btn-secondary"
							style="width: fit-content"
						>
							<span v-if="isLoading">Please wait...</span>
							<span v-else>Download List As PDF</span>
						</button>
					</div>
					<div class="table-responsive" id="printable">
						<table
							id="data-table"
							class="table table-bordered table-striped mb-0"
						>
							<thead>
								<tr>
									<!-- <th style="background: red; color: #fff">S/N</th> -->
									<th>S/N</th>
									<th style="text-wrap: auto">NAME OF ASSOCIATION</th>
									<th>ACRONYM</th>
									<th>LOGO</th>
									<th style="text-wrap: auto">ADDRESS</th>
									<th style="text-wrap: auto">PROTEM CHAIRMAN</th>
									<th style="text-wrap: auto">PROTEM SECRETARY</th>
									<th>APPLICATION STATUS</th>
									<th class="no-print">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(party, index) in parties"
									:key="'p' + party.id"
									:class="{ 'bg-light-green': index % 2 === 1 }"
								>
									<td>{{ index + 1 }}.</td>
									<td style="text-wrap: auto">{{ party.description }}</td>
									<td>{{ party.abbreviation }}</td>
									<td>
										<img :src="party.logo" height="60px" width="60px" />
									</td>
									<td style="text-wrap: auto">
										<strong>{{ party.head_office }}</strong>
									</td>
									<td style="text-wrap: auto">
										{{ party.protem_chairman ?? "Not Provided" }}
									</td>
									<td style="text-wrap: auto">
										{{ party.protem_secretary ?? "Not Provided" }}
									</td>
									<td>
										<template v-if="party.application_code">
											<span
												class="badge"
												:class="getStatusBg(party.application_code.status)"
											>
												{{ party.application_code.status }}
											</span>
										</template>
										<template v-else>
											<span class="badge bg-danger"> No Code Sent </span>
										</template>
									</td>
									<td class="no-print">
										<router-link
											:to="`/parties/${party.id}/details`"
											class="btn btn-info"
										>
											<i class="feather icon-user"></i> View
										</router-link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="parties && parties.length" class="mt-2">
						<button
							@click.prevent="downloadPDF"
							class="btn btn-secondary"
							style="width: fit-content"
						>
							<span v-if="isLoading">Please wait...</span>
							<span v-else>Download List As PDF</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- customar project  end -->
	</div>
</template>
<script>
// import Datatable from "@/utils/datatable.js";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
import { mapGetters } from "vuex";
import { userHasPermission } from "@/utils/permissions";

export default {
	computed: {
		...mapGetters({
			parties: "parties/parties",
		}),
		can_update_party() {
			return userHasPermission("parties-update");
		},
	},

	data() {
		return {
			isLoading: false,
		};
	},

	methods: {
		getParties() {
			this.$store.dispatch("parties/getPartyList");
			// .then(() => Datatable("#data-table"));
		},

		downloadPDF() {
			this.isLoading = true;
			const element = document.getElementById("printable");

			// Hide elements
			document
				.querySelectorAll(".no-print")
				.forEach((el) => (el.style.display = "none"));

			html2pdf()
				.set({
					margin: [10, 10, 10, 10], // [top, left, bottom, right]
					filename: "Intending Parties List",
					image: { type: "jpeg", quality: 0.98 },
					html2canvas: {
						scale: 2, // Higher scale = better quality
						useCORS: true, // Allow external images
					},
					jsPDF: {
						unit: "mm",
						format: "a4",
						orientation: "landscape",
					},
					pagebreak: {
						mode: ["css", "legacy"], // Breaks using CSS and default logic
					},
				})
				.from(element)
				.toContainer()
				.toCanvas()
				.toImg()
				.toPdf()
				.save()
				.then(() => {
					this.isLoading = false;
					document
						.querySelectorAll(".no-print")
						.forEach((el) => (el.style.display = ""));
				})
				.catch(() => {
					this.isLoading = false;
					document
						.querySelectorAll(".no-print")
						.forEach((el) => (el.style.display = ""));
					Swal.fire({
						icon: "error",
						text: "Failed to download pdf, please try again",
					});
				});
		},

		getStatusBg(status) {
			if (status === "Completed") {
				return "bg-info";
			}

			if (status === "Application Rejected") {
				return "bg-danger";
			}

			return "bg-success";
		},
	},

	mounted() {
		this.getParties();
	},
};
</script>
<style scoped>
.bg-info {
	background-color: #29623c !important;
}
.bg-light-green {
	background-color: #cadfb1;
}
th {
	color: black;
	font-size: 14px;
	font-weight: 700;
}
.table-bordered td,
.table-bordered th {
	border: 1px solid #000000 !important;
}
</style>
